import { Form, Input, Row } from "antd";
import React from "react";
import BannerCard from "../../../common/components/BannerCard";
import CleanButton from "../../../common/components/CleanButton";
import useProfile from "./useProfile";

const ChangePassword = ({ ...props }) => {
  const { form, handleCancel, handleChangePassword, resetPasswordLoading } = useProfile();

  return (
    <Row gutter={[14, 14]}>
      <BannerCard title="Change Password">
        <Form form={form} layout="vertical">
          <Form.Item name="currentPassword" label="Current Password" rules={[{ required: true, whitespace: true }]}>
            <Input.Password />
          </Form.Item>
          <Form.Item name="password" label="Password" rules={[{ required: true, whitespace: true }]}>
            <Input.Password />
          </Form.Item>
          <Form.Item name="retypePassword" label="Re-Type Password" rules={[{ required: true, whitespace: true }]}>
            <Input.Password />
          </Form.Item>
          <CleanButton icon="save" onClick={handleChangePassword}>
            Submit
          </CleanButton>
          <CleanButton loading={resetPasswordLoading} style={{ marginLeft: "5px" }} icon="undo" onClick={handleCancel}>
            Reset
          </CleanButton>
        </Form>
      </BannerCard>
    </Row>
  );
};

export default ChangePassword;
